"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FileUpload;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_2 = require("react-native");
const react_i18next_1 = require("react-i18next");
function FileUpload(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const [selectedFile, setSelectedFile] = react_1.default.useState(null);
    const [uploading, setUploading] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        if (selectedFile) {
            props.onFileSelected?.(selectedFile);
            props.getUploadUrl?.(selectedFile.type, selectedFile.name).then((url) => {
                return fetch(url, {
                    method: 'PUT',
                    headers: {
                        'x-goog-meta-filename': selectedFile.name
                    },
                    body: selectedFile
                });
            }).then(() => {
                props.onUploaded?.();
            }).catch((error) => {
                props.onError(error);
            }).finally(() => {
                setUploading(false);
                setSelectedFile(null);
            });
        }
    }, [selectedFile]);
    const uploadClick = (event) => {
        const file = event?.target?.files?.[0];
        if (!file) {
            setUploading(false);
            setSelectedFile(null);
            return;
        }
        const toDot = (e) => (e || '').toLowerCase().replace(/^\./, '.');
        const getExt = (name) => {
            const m = name?.toLowerCase().match(/\.([^.]+)$/);
            return m ? `${m[1]}` : '';
        };
        const allowed = (props.extensions ?? []).map(toDot);
        const ext = getExt(file.name);
        const ok = allowed.length === 0 || allowed.includes(ext);
        if (!ok) {
            react_native_2.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('common:messages.allowedFormats') + `: ${allowed.join(', ')}` });
            event.target.value = '';
            setUploading(false);
            setSelectedFile(null);
            return;
        }
        setUploading(props.getUploadUrl ? true : false);
        setSelectedFile(file);
        event.target.value = '';
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [props.style], children: (0, jsx_runtime_1.jsx)("div", { style: { fontFamily: 'Segoe UI' }, children: (0, jsx_runtime_1.jsxs)("label", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: (props.disabled || uploading) ? THEME.SolidButtonDisabled : THEME.Primary,
                    color: (props.disabled || uploading) ? THEME.TextDisabled : THEME.White,
                    borderRadius: 4,
                    padding: '8px 24px',
                    userSelect: 'none',
                    cursor: ((props.disabled || uploading) ? 'default' : 'pointer'),
                    opacity: ((props.disabled || uploading) ? 0.5 : 1.0)
                }, children: [uploading
                        &&
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Primary, size: "small", style: { marginRight: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary }, children: props.waitingText })] })
                        ||
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: props.disabled ? THEME.TextDisabled : THEME.White, icon: props.buttonIcon ?? Theme_1.ICONS.Solid.Upload, size: 14, style: { marginRight: 6, pointerEvents: 'none' } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                            fontSize: 16,
                                            color: props.disabled ? THEME.TextDisabled : THEME.White
                                        }, children: props.buttonText })] }), (0, jsx_runtime_1.jsx)("input", { type: "file", accept: props.extensions?.map(t => '.' + t)?.join(','), disabled: props.disabled || uploading, style: { display: 'none' }, onChange: (e) => uploadClick(e) })] }) }) }));
}
